import { FieldProps } from 'react-admin';
import { Chip, colors } from '@material-ui/core';

const { green, red } = colors;

type ActiveFieldProps = FieldProps & {
  colors?: string[];
  values?: string[];
};

export default function ActiveField({
  record,
  source = 'active',
  colors = [red[500], green[500]],
  values = ['Desativado', 'Ativo']
}: ActiveFieldProps) {
  if (!record) {
    return null;
  }

  return (
    <Chip
      key={record.id}
      label={values[Number(record[source])]}
      style={{
        backgroundColor: colors[Number(record[source])],
        color: '#ffffff'
      }}
    />
  );
}
